<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.002 4h-6a3 3 0 0 0-3 3v8.036a3 3 0 0 0 3 3h2.65a1 1 0 0 1 .642.233L11.359 20a1 1 0 0 0 1.28.004l2.099-1.738a1 1 0 0 1 .638-.23h2.626a3 3 0 0 0 3-3v-2.018M22 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
